import React, {Component} from 'react';

const checkMq = (mediaQuery = '') =>
  typeof window !== 'undefined' && window.matchMedia(mediaQuery).matches;

/**
 * HOC for providing matchMedia to child
 * @param {Function} WrappedComponent Component to wrap with scroll position
 * @param {Object} options Options
 * @return {Function} Component with scroll position in props
 */
function withMediaQuery(WrappedComponent, options = {}) {
  return class extends Component {
    state = {
      matches: checkMq(options.mediaQuery),
    };

    handleResize = () => {
      let ticking = false;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.setState({
            matches: checkMq(options.mediaQuery),
          });
          ticking = false;
        });

        ticking = true;
      }
    };

    componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.handleResize);
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    render() {
      return <WrappedComponent matches={this.state.matches} {...this.props} />;
    }
  };
}

export default withMediaQuery;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/WithMediaQuery/index.js